import { gql } from '@apollo/client';
import { CRM_FORM_FIELDS } from './queries';

export const CREATE_CRM_FORM = gql`
    mutation CreateCrmForm($input: CreateCrmFormInput!) {
        createCrmForm(input: $input) {
            ${CRM_FORM_FIELDS}
        }
    }
`;

export const UPDATE_CRM_FORM = gql`
    mutation UpdateCrmForm($input: UpdateCrmFormInput!) {
        updateCrmForm(input: $input) {
            ${CRM_FORM_FIELDS}
        }
    }
`;

export const DELETE_CRM_FORM = gql`
    mutation DeleteCrmForm($id: String!) {
        deleteCrmForm(id: $id) {
            _id
            name
        }
    }
`;
